window.cookieconsent_options = {
  'message': 'Spletno mesto uporablja piškotke za zagotavljanje boljše uporabniške izkušnje in spremljanje statistike obiska.',
  'dismiss': 'V redu',
  'theme': false
}